var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"emotion-box",style:({height: _vm.height + 'px' })},_vm._l((_vm.list),function(line,i){return _c('div',{key:i,staticClass:"emotion-box-line"},_vm._l((line),function(item,i){return _c('emotion',{key:i,staticClass:"emotion-item",nativeOn:{"click":function($event){_vm.clickHandler(item)}}},[_vm._v(_vm._s(item))])}))}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8be9546e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Emotion/index.vue
// module id = null
// module chunks = 